import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext } from 'react';
const SettingsContext = createContext(undefined);
export const useSettings = () => {
    const context = useContext(SettingsContext);
    if (!context) {
        throw new Error('useSettings must be used within a SettingsProvider');
    }
    return context;
};
export const SettingsProvider = ({ children, settings }) => {
    return _jsx(SettingsContext.Provider, { value: settings, children: children });
};
//# sourceMappingURL=SettingsContext.js.map